module.exports = __webpack_public_path__ + "static/img/Classical.ecbc79c.png";


//////////////////
// WEBPACK FOOTER
// ./static/banners/Classical.png
// module id = 2234
// module chunks = 61